import { render, staticRenderFns } from "./GoalsDialogComponent.vue?vue&type=template&id=34e73c58&scoped=true"
import script from "./GoalsDialogComponent.js?vue&type=script&lang=js&external"
export * from "./GoalsDialogComponent.js?vue&type=script&lang=js&external"
import style0 from "./GoalsDialogComponent.vue?vue&type=style&index=0&id=34e73c58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e73c58",
  null
  
)

export default component.exports